<section class="order-address-container">
  <div class="order-shipping-address">
    <div class="address-container-title">{{ 'text_shippingAddress' | dbText }}</div>
    <div class="address-container-body">
      <div class="address-line-container">
        <div class="address-line-title">{{ 'text_address1' | dbText }}</div>
        <div class="address-line-value">{{order?.shipping.address_1}}</div>
        <div class="address-line-copy">
          <input #add1 type="text" [value]="order?.shipping.address_1" readonly/>
          <i class="db-icon db-icon-ds-copy"
             ngxClipboard [cbContent]="order?.shipping.address_1"
             #copyIcon
             (cbOnSuccess)="copyList.shipping.address1 = true"
             (click)="copyList.shipping.address1 = true"
             (onTooltipHide)="copyList.shipping.address1 = false"
             dsTooltipMode="click"
             dsTooltipSize="small"
             dsTooltipPosition="top"
             dsTooltipColor="black"
             dsTooltipZIndex="1000000000"
             [dsTooltip]="'<b>' + ((copyList.shipping.address1 ? 'text_copied' : 'text_copy') | dbText) +'</b>'"></i>
        </div>
      </div>
      <div class="address-line-container">
        <div class="address-line-title">{{ 'text_address2' | dbText }}</div>
        <div class="address-line-value">{{order?.shipping.address_2}}</div>
        <div class="address-line-copy">
          <i class="db-icon db-icon-ds-copy"
             ngxClipboard
             [cbContent]="order?.shipping.address_2"
             #copyIcon
             (cbOnSuccess)="copyList.shipping.address2 = true"
             (click)="copyList.shipping.address2 = true"
             (onTooltipHide)="copyList.shipping.address2 = false"
             dsTooltipMode="click"
             dsTooltipSize="small"
             dsTooltipPosition="top"
             dsTooltipColor="black"
             dsTooltipZIndex="1000000000"
             [dsTooltip]="'<b>' + ((copyList.shipping.address2 ? 'text_copied' : 'text_copy') | dbText) +'</b>'"></i>
        </div>
      </div>
      <div class="address-line-container">
        <div class="address-line-title">{{ 'text_city' | dbText }}</div>
        <div class="address-line-value">{{order?.shipping.city}}</div>
        <div class="address-line-copy">
          <i class="db-icon db-icon-ds-copy"
             ngxClipboard
             [cbContent]="order?.shipping.city"
             (cbOnSuccess)="copyList.shipping.city = true"
             (click)="copyList.shipping.city = true"
             (onTooltipHide)="copyList.shipping.city = false"
             dsTooltipMode="click"
             dsTooltipSize="small"
             dsTooltipPosition="top"
             dsTooltipColor="black"
             dsTooltipZIndex="1000000000"
             [dsTooltip]="'<b>' + ((copyList.shipping.city ? 'text_copied' : 'text_copy') | dbText) +'</b>'"></i>
        </div>
      </div>
      <div class="address-line-container">
        <div class="address-line-title">{{ 'text_postCode' | dbText }}</div>
        <div class="address-line-value">{{order?.shipping.postcode}}</div>
        <div class="address-line-copy">
          <i class="db-icon db-icon-ds-copy"
             ngxClipboard
             [cbContent]="order?.shipping.postcode"
             (cbOnSuccess)="copyList.shipping.postcode = true"
             (click)="copyList.shipping.postcode = true"
             (onTooltipHide)="copyList.shipping.postcode = false"
             dsTooltipMode="click"
             dsTooltipSize="small"
             dsTooltipPosition="top"
             dsTooltipColor="black"
             dsTooltipZIndex="1000000000"
             [dsTooltip]="'<b>' + ((copyList.shipping.postcode ? 'text_copied' : 'text_copy') | dbText) +'</b>'"></i>
        </div>
      </div>
      <div class="address-line-container">
        <div class="address-line-title">{{ 'text_country' | dbText }}</div>
        <div class="address-line-value">{{order?.shipping.country}}</div>
        <div class="address-line-copy">
          <i class="db-icon db-icon-ds-copy"
             ngxClipboard
             [cbContent]="order?.shipping.country"
             (cbOnSuccess)="copyList.shipping.country = true"
             (click)="copyList.shipping.country = true"
             (onTooltipHide)="copyList.shipping.country = false"
             dsTooltipMode="click"
             dsTooltipSize="small"
             dsTooltipPosition="top"
             dsTooltipColor="black"
             dsTooltipZIndex="1000000000"
             [dsTooltip]="'<b>' + ((copyList.shipping.country ? 'text_copied' : 'text_copy') | dbText) +'</b>'"></i>
        </div>
      </div>
      <div class="address-line-container">
        <div class="address-line-title">{{ 'text_state' | dbText }}</div>
        <div class="address-line-value">{{order?.shipping.state}}</div>
        <div class="address-line-copy">
          <i class="db-icon db-icon-ds-copy"
             ngxClipboard
             [cbContent]="order?.shipping.state"
             (cbOnSuccess)="copyList.shipping.state = true"
             (click)="copyList.shipping.state = true"
             (onTooltipHide)="copyList.shipping.state = false"
             dsTooltipMode="click"
             dsTooltipSize="small"
             dsTooltipPosition="top"
             dsTooltipColor="black"
             dsTooltipZIndex="1000000000"
             [dsTooltip]="'<b>' + ((copyList.shipping.state ? 'text_copied' : 'text_copy') | dbText) +'</b>'"></i>
        </div>
      </div>
    </div>
  </div>
  <div class="divider"></div>
  <div class="order-billing-address">
    <div class="address-container-title">{{ 'text_billingAddress' | dbText }}</div>
    <div class="address-container-body">
      <div class="address-line-container">
        <div class="address-line-title">{{ 'text_address1' | dbText }}</div>
        <div class="address-line-value">{{order?.billing.address_1}}</div>
        <div class="address-line-copy">
          <i class="db-icon db-icon-ds-copy"
             ngxClipboard
             [cbContent]="order?.billing.address_1"
             (cbOnSuccess)="copyList.billing.address1 = true"
             (click)="copyList.billing.address1 = true"
             (onTooltipHide)="copyList.billing.address1 = false"
             dsTooltipMode="click"
             dsTooltipSize="small"
             dsTooltipPosition="top"
             dsTooltipColor="black"
             dsTooltipZIndex="1000000000"
             [dsTooltip]="'<b>' + ((copyList.billing.address1 ? 'text_copied' : 'text_copy') | dbText) +'</b>'"></i>
        </div>
      </div>
      <div class="address-line-container">
        <div class="address-line-title">{{ 'text_address2' | dbText }}</div>
        <div class="address-line-value">{{order?.billing.address_2}}</div>
        <div class="address-line-copy">
          <i class="db-icon db-icon-ds-copy"
             ngxClipboard
             [cbContent]="order?.billing.address_2"
             (cbOnSuccess)="copyList.billing.address2 = true"
             (click)="copyList.billing.address2 = true"
             (onTooltipHide)="copyList.billing.address2 = false"
             dsTooltipMode="click"
             dsTooltipSize="small"
             dsTooltipPosition="top"
             dsTooltipColor="black"
             dsTooltipZIndex="1000000000"
             [dsTooltip]="'<b>' + ((copyList.billing.address2 ? 'text_copied' : 'text_copy') | dbText) +'</b>'"></i>
        </div>
      </div>
      <div class="address-line-container">
        <div class="address-line-title">{{ 'text_city' | dbText }}</div>
        <div class="address-line-value">{{order?.billing.city}}</div>
        <div class="address-line-copy">
          <i class="db-icon db-icon-ds-copy"
             ngxClipboard
             [cbContent]="order?.billing.city"
             (cbOnSuccess)="copyList.billing.city = true"
             (click)="copyList.billing.city = true"
             (onTooltipHide)="copyList.billing.city = false"
             dsTooltipMode="click"
             dsTooltipSize="small"
             dsTooltipPosition="top"
             dsTooltipColor="black"
             dsTooltipZIndex="1000000000"
             [dsTooltip]="'<b>' + ((copyList.billing.city ? 'text_copied' : 'text_copy') | dbText) +'</b>'"></i>
        </div>
      </div>
      <div class="address-line-container">
        <div class="address-line-title">{{ 'text_postCode' | dbText }}</div>
        <div class="address-line-value">{{order?.billing.postcode}}</div>
        <div class="address-line-copy">
          <i class="db-icon db-icon-ds-copy"
             ngxClipboard
             [cbContent]="order?.billing.postcode"
             (cbOnSuccess)="copyList.billing.postcode = true"
             (click)="copyList.billing.postcode = true"
             (onTooltipHide)="copyList.billing.postcode = false"
             dsTooltipMode="click"
             dsTooltipSize="small"
             dsTooltipPosition="top"
             dsTooltipColor="black"
             dsTooltipZIndex="1000000000"
             [dsTooltip]="'<b>' + ((copyList.billing.postcode ? 'text_copied' : 'text_copy') | dbText) +'</b>'"></i>
        </div>
      </div>
      <div class="address-line-container">
        <div class="address-line-title">{{ 'text_country' | dbText }}</div>
        <div class="address-line-value">{{order?.billing.country}}</div>
        <div class="address-line-copy">
          <i class="db-icon db-icon-ds-copy"
             ngxClipboard
             [cbContent]="order?.billing.country"
             (cbOnSuccess)="copyList.billing.country = true"
             (click)="copyList.billing.country = true"
             (onTooltipHide)="copyList.billing.country = false"
             dsTooltipMode="click"
             dsTooltipSize="small"
             dsTooltipPosition="top"
             dsTooltipColor="black"
             dsTooltipZIndex="1000000000"
             [dsTooltip]="'<b>' + ((copyList.billing.country ? 'text_copied' : 'text_copy') | dbText) +'</b>'"></i>
        </div>
      </div>
      <div class="address-line-container">
        <div class="address-line-title">{{ 'text_state' | dbText }}</div>
        <div class="address-line-value">{{order?.billing.state}}</div>
        <div class="address-line-copy">
          <i class="db-icon db-icon-ds-copy"
             ngxClipboard
             [cbContent]="order?.billing.state"
             (cbOnSuccess)="copyList.billing.state = true"
             (click)="copyList.billing.state = true"
             (onTooltipHide)="copyList.billing.state = false"
             dsTooltipMode="click"
             dsTooltipSize="small"
             dsTooltipPosition="top"
             dsTooltipColor="black"
             dsTooltipZIndex="1000000000"
             [dsTooltip]="'<b>' + ((copyList.billing.state ? 'text_copied' : 'text_copy') | dbText) +'</b>'"></i>
        </div>
      </div>
    </div>
  </div>
</section>
